module.exports = __webpack_public_path__ + "img/fail.67bac0fe.svg";